var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { FormGroup, InputGroup, NumericInput, FileInput, TextArea } from '@blueprintjs/core';
import { DateInput, TimePrecision } from '@blueprintjs/datetime';
import { SecondsInYear } from '@patterns/core';
import { FlexColumn, FlexRow } from '@patterns/ui';
import deepEqual from 'fast-deep-equal';
import { FormFieldType } from './types';
import { FormGlobal } from './form-global';
var MaxDate = new Date(new Date().getTime() + SecondsInYear * 20 * 1000);
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            initialized: false,
            dateValues: {},
            fileValues: {},
            imageValues: {},
            stringValues: {},
            numberValues: {},
            customValues: {}
        };
        _this.updateState = function () {
            var dateValues = {};
            var fileValues = {};
            var stringValues = {};
            var numberValues = {};
            var imageValues = {};
            var customValues = {};
            _this.props.fields.forEach(function (field) {
                var value = _this.props.item[field.id];
                switch (field.type) {
                    case FormFieldType.Text:
                        stringValues[field.id] = value;
                        break;
                    case FormFieldType.TextArea:
                        stringValues[field.id] = value;
                        break;
                    case FormFieldType.Number:
                        numberValues[field.id] = value;
                        break;
                    case FormFieldType.Date:
                        dateValues[field.id] = value;
                        break;
                    case FormFieldType.DateTime:
                        dateValues[field.id] = value;
                        break;
                    case FormFieldType.File:
                        fileValues[field.id] = value;
                        imageValues[field.id] = URL.createObjectURL(value);
                        break;
                    case FormFieldType.Custom:
                        customValues[field.id] = value;
                    default:
                        break;
                }
            });
            _this.setState({
                initialized: true,
                dateValues: dateValues,
                fileValues: fileValues,
                imageValues: imageValues,
                stringValues: stringValues,
                numberValues: numberValues,
                customValues: customValues
            });
        };
        _this.onChange = function (field) { return __awaiter(_this, void 0, void 0, function () {
            var newItem;
            var _this = this;
            return __generator(this, function (_a) {
                newItem = Object.assign({}, this.props.item);
                this.props.fields.forEach(function (field) {
                    switch (field.type) {
                        case FormFieldType.Text:
                            newItem[field.id] = _this.state.stringValues[field.id];
                            break;
                        case FormFieldType.TextArea:
                            newItem[field.id] = _this.state.stringValues[field.id];
                            break;
                        case FormFieldType.Number:
                            newItem[field.id] = _this.state.numberValues[field.id];
                            break;
                        case FormFieldType.Date:
                            newItem[field.id] = _this.state.dateValues[field.id];
                            break;
                        case FormFieldType.DateTime:
                            newItem[field.id] = _this.state.dateValues[field.id];
                            break;
                        case FormFieldType.File:
                            newItem[field.id] = _this.state.fileValues[field.id];
                            break;
                        case FormFieldType.ImageFile:
                            newItem[field.id] = _this.state.fileValues[field.id];
                            break;
                        default:
                            break;
                    }
                });
                this.props.onChange(newItem, field, this.props.item);
                return [2 /*return*/];
            });
        }); };
        _this.onDateChange = function (value, isUserChange, name) { return __awaiter(_this, void 0, void 0, function () {
            var newValues;
            var _this = this;
            return __generator(this, function (_a) {
                newValues = Object.assign({}, this.state.dateValues);
                newValues[name] = value;
                this.setState({ dateValues: newValues }, function () { return _this.onChange(name); });
                return [2 /*return*/];
            });
        }); };
        _this.onNumberChange = function (value, stringValue, inputElement) { return __awaiter(_this, void 0, void 0, function () {
            var name, newValues;
            var _this = this;
            return __generator(this, function (_a) {
                name = inputElement.name;
                newValues = Object.assign({}, this.state.numberValues);
                newValues[name] = value;
                this.setState({ numberValues: newValues }, function () { return _this.onChange(name); });
                return [2 /*return*/];
            });
        }); };
        _this.onStringChange = function (evt) { return __awaiter(_this, void 0, void 0, function () {
            var name, value, newValues;
            var _this = this;
            return __generator(this, function (_a) {
                name = evt.currentTarget.name;
                value = evt.currentTarget.value;
                newValues = Object.assign({}, this.state.stringValues);
                newValues[name] = value;
                this.setState({ stringValues: newValues }, function () { return _this.onChange(name); });
                return [2 /*return*/];
            });
        }); };
        _this.onFileChange = function (evt) { return __awaiter(_this, void 0, void 0, function () {
            var newValues, name;
            var _this = this;
            return __generator(this, function (_a) {
                newValues = Object.assign({}, this.state.fileValues);
                name = evt.currentTarget.name;
                newValues[name] = evt.currentTarget.files[0];
                this.setState({ fileValues: newValues }, function () { return _this.onChange(name); });
                return [2 /*return*/];
            });
        }); };
        _this.onImageFileChange = function (evt) { return __awaiter(_this, void 0, void 0, function () {
            var newValues, newImageValues, name;
            var _this = this;
            return __generator(this, function (_a) {
                newValues = Object.assign({}, this.state.fileValues);
                newImageValues = Object.assign({}, this.state.imageValues);
                name = evt.currentTarget.name;
                newValues[name] = evt.currentTarget.files[0];
                newImageValues[name] = URL.createObjectURL(evt.currentTarget.files[0]);
                this.setState({
                    fileValues: newValues,
                    imageValues: newImageValues
                }, function () { return _this.onChange(name); });
                return [2 /*return*/];
            });
        }); };
        _this.renderField = function (field) {
            var intent = field.validation ? (field.validation(_this.props.item) ? 'success' : 'danger') : 'none';
            switch (field.type) {
                case FormFieldType.Text:
                    return React.createElement(InputGroup, { fill: _this.props.fill, disabled: field.disabled, placeholder: field.hint, name: field.id, intent: intent, value: _this.state.stringValues[field.id] || '', onChange: _this.onStringChange });
                case FormFieldType.TextArea:
                    return React.createElement(TextArea, { fill: _this.props.fill, disabled: field.disabled, placeholder: field.hint, name: field.id, intent: intent, value: _this.state.stringValues[field.id] || '', onChange: _this.onStringChange });
                case FormFieldType.Number:
                    return React.createElement(NumericInput, { fill: _this.props.fill, disabled: field.disabled, placeholder: field.hint, name: field.id, intent: intent, value: _this.state.numberValues[field.id], onValueChange: _this.onNumberChange });
                case FormFieldType.Date:
                    return React.createElement(DateInput, { fill: _this.props.fill, disabled: field.disabled, placeholder: field.hint, inputProps: {
                            name: field.id,
                            intent: intent
                        }, canClearSelection: false, maxDate: MaxDate, parseDate: FormGlobal.parseDate, formatDate: FormGlobal.formatDate, value: _this.state.dateValues[field.id], onChange: function (value, isUserChange) { return _this.onDateChange(value, isUserChange, field.id); } });
                case FormFieldType.DateTime:
                    return React.createElement(DateInput, { fill: _this.props.fill, placeholder: field.hint, disabled: field.disabled, timePrecision: TimePrecision.MINUTE, maxDate: MaxDate, inputProps: {
                            name: field.id
                        }, parseDate: FormGlobal.parseDate, formatDate: FormGlobal.formatDateTime, value: _this.state.dateValues[field.id], onChange: function (value, isUserChange) { return _this.onDateChange(value, isUserChange, field.id); } });
                case FormFieldType.File:
                    return React.createElement(FileInput, { fill: _this.props.fill, inputProps: {
                            name: field.id
                        }, disabled: field.disabled, hasSelection: typeof _this.state.fileValues[field.id] !== 'undefined', text: typeof _this.state.fileValues[field.id] === 'undefined' ? field.hint : _this.state.fileValues[field.id].name, buttonText: "...", onInputChange: _this.onFileChange });
                case FormFieldType.ImageFile:
                    return React.createElement(FlexRow, null,
                        React.createElement("img", { src: _this.state.imageValues[field.id], className: "patterns-form-image" }),
                        React.createElement(FileInput, { fill: _this.props.fill, inputProps: {
                                name: field.id,
                            }, disabled: field.disabled, hasSelection: typeof _this.state.fileValues[field.id] !== 'undefined', text: typeof _this.state.fileValues[field.id] === 'undefined' ? field.hint : _this.state.fileValues[field.id].name, buttonText: "...", onInputChange: _this.onImageFileChange }));
                case FormFieldType.Custom:
                    return field.customElement(_this.props.item, function (item) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            this.props.onChange(item, field.id);
                            return [2 /*return*/];
                        });
                    }); });
            }
        };
        _this.renderFields = function () {
            var inline = _this.props.inline || false;
            var className = _this.props.fill ? "patterns-form-field-group patterns-form-field-group-fill" : 'patterns-form-field-group';
            return _this.props.fields.map(function (field) {
                return React.createElement(FormGroup, { key: "form-field-" + field.id, disabled: field.disabled, className: className, inline: inline, intent: field.validation ? (field.validation(_this.props.item) ? 'success' : 'danger') : 'none', label: field.validation ? field.label + "*" : field.label }, _this.renderField(field));
            });
        };
        return _this;
    }
    Form.ofType = function () {
        return Form;
    };
    Form.prototype.componentDidMount = function () {
        this.updateState();
    };
    Form.prototype.componentDidUpdate = function (prevProps) {
        if (!deepEqual(prevProps.item, this.props.item) || !deepEqual(prevProps.fields, this.props.fields)) {
            this.updateState();
        }
    };
    Form.prototype.render = function () {
        if (!this.state.initialized) {
            return React.createElement("span", null);
        }
        var className = "patterns-form " + (this.props.className || '');
        return React.createElement(FlexColumn, { className: className },
            this.renderFields(),
            this.props.after && this.props.after);
    };
    return Form;
}(React.Component));
export { Form };
//# sourceMappingURL=form.js.map